import React, { Component } from "react";
import VirtualList from "react-tiny-virtual-list";
import classNames from "classnames";
import { emptyFn, getMonthsForYear } from "../utils";
import format from "date-fns/format";
import isAfter from "date-fns/is_after";
import isBefore from "date-fns/is_before";
import isSameMonth from "date-fns/is_same_month";
import styles from "./Years.scss";
import _ from "lodash";
import { arrayOf, bool, func, instanceOf, number, objectOf, oneOf, oneOfType, shape, string } from "prop-types";

const SPACING = 40;

export default class Years extends Component {
    static propTypes = {
        height: number,
        hideOnSelect: bool,
        locale: shape({
            blank: string,
            headerFormat: string,
            todayLabel: shape({
                long: string,
                short: string
            }),
            weekdays: arrayOf(string),
            weekStartsOn: oneOf([0, 1, 2, 3, 4, 5, 6])
        }),
        max: instanceOf(Date),
        maxDate: instanceOf(Date),
        min: instanceOf(Date),
        minDate: instanceOf(Date),
        scrollToDate: func,
        setDisplay: func,
        theme: shape({
            floatingNav: shape({
                background: string,
                chevron: string,
                color: string
            }),
            headerColor: string,
            selectionColor: oneOfType([string, func]),
            textColor: shape({
                active: string,
                default: string
            }),
            todayColor: string,
            weekdayColor: string
        }),
        width: oneOfType([number, string]),
        years: arrayOf(number),
        today: instanceOf(Date),
        dataCollected: objectOf(objectOf(string)),
        selected: objectOf(instanceOf(Date)),
        showMonths: bool,
        onSelect: func
    };

    static defaultProps = {
        onSelect: emptyFn,
        showMonths: true
    };

    handleClick = date => e => {
        let {
            hideOnSelect,
            onSelect,
            setDisplay,
            scrollToDate
        } = this.props;

        onSelect(date, e, (date) => scrollToDate(date));

        if (hideOnSelect) {
            window.requestAnimationFrame(() => setDisplay("days"));
        }
    };

    handleClickItemYear = (date, isDisabled) => e => {
        let {
            hideOnSelect,
            onSelect,
            setDisplay,
            scrollToDate
        } = this.props;
        e.stopPropagation();
        if (!isDisabled) {
            // this.handleClick(date, e);
            onSelect(date, e, (date) => scrollToDate(date));
            if (hideOnSelect) {
                window.requestAnimationFrame(() => setDisplay("days"));
            }
        }
    };

    renderMonths(year) {
        const { locale: { locale }, selected, theme, today, min, max, minDate, maxDate } = this.props;
        const months = getMonthsForYear(year, selected.getDate());

        return (
            <ol>
                {months.map((date, index) => {
                    const isSelected = isSameMonth(date, selected);
                    const isCurrentMonth = isSameMonth(date, today);
                    const isDisabled = (
                        isBefore(date, min) ||
                        isBefore(date, minDate) ||
                        isAfter(date, max) ||
                        isAfter(date, maxDate)
                    );
                    const style = Object.assign({}, isSelected && {
                        backgroundColor: (
                            _.isFunction(theme.selectionColor)
                                ? theme.selectionColor(date)
                                : theme.selectionColor
                        )
                    }, isCurrentMonth && {
                        borderColor: theme.todayColor
                    });

                    return (
                        <li
                            key={date}
                            onClick={this.handleClickItemYear(date, isDisabled)}
                            className={classNames(styles.month, {
                                [styles.selected]: isSelected,
                                [styles.currentMonth]: isCurrentMonth,
                                [styles.disabled]: isDisabled
                            })}
                            style={style}
                            title={`Set date to ${format(date, "MMMM Do, YYYY")}`}
                        >
                            {format(date, "MMM", { locale })}
                        </li>
                    );
                })}
            </ol>
        );
    }

    renderItem = ({ index, style }) => {
        const {  selected, showMonths, theme, today, dataCollected } = this.props;
        const currentYear = today.getFullYear();
        const years = this.props.years.slice(0, this.props.years.length);
        const selectedYearIndex = years.indexOf(selected.getFullYear());

        const listTitle = ["Google Analytics", "Spot Data Available", "Live Reads Available", "Watchlists Available"];
        let dataShow = [];
        listTitle.map(item => {
            dataShow.push({
                ...dataCollected[item],
                name: item
            });
        });

        dataShow = dataShow.filter(item => {
            return item.startDate !== "N/A";
        });

        const year = years[index];
        const isActive = index === selectedYearIndex;

        return (
            <div
                key={index}
                className={classNames(styles.year, {
                    [styles.active]: !showMonths && isActive,
                    [styles.currentYear]: !showMonths && year === currentYear,
                    [styles.withMonths]: showMonths,
                    [styles.first]: index === 0,
                    [styles.last]: index === years.length - 1
                })}
                onClick={this.handleClick(new Date(selected).setYear(year))}
                title={`Set year to ${year}`}
                data-year={year}
                style={Object.assign({}, style, {
                    color: (
                        _.isFunction(theme.selectionColor)
                            ? theme.selectionColor(new Date(year, 0, 1))
                            : theme.selectionColor
                    )
                })}
            >
                <label style={{ padding: "36px 0" }}>
        <span
            style={
                !showMonths && year === currentYear
                    ? { borderColor: theme.todayColor }
                    : null
            }
        >
    {year}
  </span>
                </label>
                {showMonths && this.renderMonths(year)}
            </div>
        );
    }

    getHeight = (index) => {
        const { showMonths} = this.props;
        
        const years = this.props.years.slice(0, this.props.years.length);
        const rowHeight = showMonths ? 110 : 50;
        const heights = years.map((val, index) => index === 0 || index === years.length - 1
            ? rowHeight + SPACING
            : rowHeight
        );
        return heights[index];
    }

    render() {
        const { height, selected, showMonths, theme, width, dataCollected } = this.props;
        const years = this.props.years.slice(0, this.props.years.length);
        const selectedYearIndex = years.indexOf(selected.getFullYear());
        const rowHeight = showMonths ? 110 : 50;

        const listTitle = ["Google Analytics", "Spot Data Available", "Live Reads Available", "Watchlists Available"];
        let dataShow = [];
        listTitle.map(item => {
            dataShow.push({
                ...dataCollected[item],
                name: item
            });
        });

        dataShow = dataShow.filter(item => {
            return item.startDate !== "N/A";
        });

        let addHeight = 0;
        if (dataShow.length === 0) {
            addHeight = 50;
        } else {
            addHeight = dataShow.length * 50;
        }
        const containerHeight = years.length * rowHeight < height + addHeight
            ? years.length * rowHeight
            : height + addHeight;


        return (
            <div
                className={styles.root}
                style={{ color: theme.selectionColor, height: height + addHeight }}
            >
                <VirtualList
                    className={styles.list}
                    width={width}
                    height={containerHeight}
                    itemCount={years.length}
                    estimatedItemSize={rowHeight}
                    itemSize={this.getHeight}
                    scrollToIndex={selectedYearIndex !== -1 ? selectedYearIndex : null}
                    scrollToAlignment='center'
                    renderItem={this.renderItem}
                />
            </div>
        );
    }
}